module.exports = __webpack_public_path__ + "img/empty-image.3156efdb.jpg";